import { Schema } from "@comparaonline/products-schema";

import { getProductImage } from "../getProductImage";

const MIN_RATING_COUNT = 1;

const buildRatingSchema = (review?: Schema.ProductListReviews | null) => ({
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: review ? review.averageValue : 0,
    ratingCount: review ? Math.max(review.total, MIN_RATING_COUNT) : MIN_RATING_COUNT,
    worstRating: 0
  }
});

const buildImageSchema = (product: Schema.ProductListProduct) => {
  const { alt, src } = getProductImage(product);
  return {
    "@type": "ImageObject",
    url: src,
    name: alt
  };
};

export const buildBaseSchema = (product: Schema.ProductListProduct) => ({
  "@context": "http://schema.org",
  "@type": "Product",
  name: product.name,
  brand: product.division.name,
  image: buildImageSchema(product)
});

export const buildProductSchema = (product: Schema.ProductListProduct) => {
  const productSchema = buildBaseSchema(product);
  const ratingSchema = buildRatingSchema(product.reviews);
  return {
    ...productSchema,
    ...ratingSchema
  };
};
